<template>
  <div class="tabbar">
    <div
      :class="['item', props.index == item.text ? 'active' : '']"
      v-for="(item, index) in items"
      :key="index"
      @click="linkTo(item.link)"
    >
      <div :class="['iconfont', item.icon]"></div>
      <div>{{ item.text }}</div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, onMounted } from "vue";
import routers from "@/hooks/routers";
import { useStore } from "vuex";

export default defineComponent({
  name: "Tabbar",
  props: ["index"],
  setup(props) {
    let items = reactive([
      { text: "首页", icon: "icon-shouye", link: "/" },
      { text: "记录", icon: "icon-jilu", link: "/record" },
      { text: "我的", icon: "icon-weibiaoti--", link: "/my" },
    ]);
    const store = useStore();

    //路由跳转
    const { linkTo } = routers();

    onMounted(() => {
      setTimeout(() => {
        if (store.state.partnerConfig) {
          // 配置tabBar
          let arr = store.state.partnerConfig.basic?.page_table.split(",");
          if (arr && arr.length == 0) {
            items.splice(1, 2);
          } else if (arr && arr.length == 1) {
            if (arr[0] === "记录页") {
              items.splice(2, 1);
            } else if (arr[0] === "个人中心") {
              items.splice(1, 1);
            }
          } else {
            return;
          }
        }
      }, 30);
    });

    return { items, props, linkTo };
  },
});
</script>

<style lang="scss" scoped>
.tabbar {
  position: fixed;
  z-index: 99;
  width: 100%;
  left: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.1rem 0;
  .item {
    flex: 1;
    text-align: center;
    font-size: 0.14rem;
    .iconfont {
      font-size: 0.25rem;
      margin: 0 0 0.05rem;
    }
    &.active {
      color: var(--themeColor);
    }
  }
}
</style>
